import { useRouter } from 'expo-router'
import { FormattedMessage } from 'react-intl'

import { EmptyState } from '@/src/general/components/EmptyState'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'

export const JourneySliderEmptyState = () => {
  const router = useRouter()
  const { routes } = useRoutes()

  return (
    <EmptyState
      icon={ICON.PATH}
      title={<FormattedMessage id="journey.none.now" />}
      description={<FormattedMessage id="journey.once.subscribed" />}
      button={{
        variant: 'solid',
        colors: 'primary',
        onPress: () => router.navigate(routes.communitiesCategory('currently')),
        children: <FormattedMessage id="journey.discover.current" />,
      }}
    />
  )
}
